<template>
  <div class="page-container">
    <div class="full-height-container h-full sm:h-full md:h-screen">
      <div class="flex flex-wrap">
        <div
          class="w-full sm:w-1/1 md:w-1/2 h-64 sm:h-64 md:h-screen"
        >
          <img
            class="w-full h-64 sm:h-64 md:h-screen object-cover object-center"
            src="@/assets/img/demo6.png"
            alt="Toyota"
          />
        </div>
        <!-- ... -->
        <div
          class="w-full sm:w-1/1 md:w-1/2 authorize-container h-auto sm:h-auto md:h-screen"
        >
          <div
            class="flex flex-col justify-center sm:min-auto min-h-full"
          >
            <h1 class="mb-8">
              <router-link :to="{ name: 'index'}" class="main-logo">
                <img src="@/assets/img/logo.png" alt="Toyota" />
              </router-link>
            </h1>
            <p class="text-center mb-0">
              <img
                class="m-auto"
                width="250px"
                src="@/assets/img/completed.png"
                alt="Toyota"
              />
            </p>
            <p class="text-center page-text-medium">
              Mật khẩu thay đổi thành công!
            </p>
            <div>
              <router-link :to="{ name: 'loanSummary'}"  tag="button"
                class="submit-button block mt-8 w-full mb-2 bg-red-500 hover:bg-red-400 text-white font-bold py-2 px-4 border-red-700 hover:border-red-500 rounded"
              >
                Trở về trang chủ
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ResetPasswordSuccess',
  data () {
    return {
    }
  },

  methods: {
  }
}
</script>
